module.exports = __webpack_public_path__ + "media/tape-nav/community-feed-icon-cda3eefe.svg";